module.exports = __webpack_public_path__ + "img/38.d95a7022.jpg";